import { Field } from "formik";
import { FtextField } from "../../../../../components/common/FtextField";
import { useTranslation } from "react-i18next";

const BkashForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="displayGrid3">
        <FtextField
          required
          type="text"
          label={t("userName")}
          name="settings.paymentGateway.bKash.username"
          validation={true}
        />

        <FtextField
          required
          type="password"
          label={t("password")}
          name="settings.paymentGateway.bKash.password"
          validation={true}
        />

        <FtextField
          required
          type="text"
          label={t("appKey")}
          name="settings.paymentGateway.bKash.appKey"
          validation={true}
        />

        <FtextField
          required
          type="text"
          label={t("appSecret")}
          name="settings.paymentGateway.bKash.appSecret"
          validation={true}
        />
      </div>

      <div className="displayGrid3">
        <div className="form-check mt-4">
          <Field
            className="form-check-input"
            type="checkbox"
            id="isTokenized"
            name="settings.paymentGateway.bKash.isTokenized"
          />
          <label className="form-check-label" for="isTokenized">
            {t("isTokenized")} <span className="text-danger me-4">*</span>
          </label>
        </div>

        <div className="form-check mt-4">
          <Field
            className="form-check-input"
            type="checkbox"
            id="bKash"
            name="settings.paymentGateway.providers.bKash"
          />
          <label className="form-check-label" for="bKash">
            {t("hasGateway")} <span className="text-danger ms-1">*</span>
          </label>
        </div>

        <div className="form-check mt-4">
          <Field
            className="form-check-input"
            type="checkbox"
            id="hasPG"
            name="settings.paymentGateway.hasPG"
          />
          <label className="form-check-label" for="hasPG">
            {t("hasPG")} <span className="text-danger me-4">*</span>
          </label>
        </div>
      </div>
    </>
  );
};

export default BkashForm;
